import EventBusyOutlined from '@mui/icons-material/EventBusyOutlined';
import { Box } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { BreadcrumbMeta } from 'v2/components/Breadcrumb/Breadcrumb';
import EmptyStateOverview from 'v2/components/EmptyStateOverview/EmptyStateOverview';
import OverviewContent from 'v2/components/OverviewContent/OverviewContent';
import PageTabs from 'v2/components/PageTabs/PageTabs';
import SearchAndFilters, { FilterChip, FilterSection } from 'v2/components/SearchAndFilters/SearchAndFilters';
import { createVisitsTabs } from 'v2/pages/Visits/createVisitsTabs';

interface Props {
  breadcrumbTitle: string;
  statTiles?: React.ReactNode;
  filterStr: string;
  onFilterStrChange: (value: string) => void;
  sections: FilterSection[];
  chips: FilterChip[];
  countCaption: string;
  loading: boolean;
  hasData: boolean;
  hasResults: boolean;
  table: React.ReactNode;
  noDataTitle: string;
  noDataContent: string;
}

const VisitsPageContent: React.FC<Props> = ({
  breadcrumbTitle,
  statTiles,
  filterStr,
  onFilterStrChange,
  sections,
  chips,
  countCaption,
  loading,
  hasData,
  hasResults,
  table,
  noDataTitle,
  noDataContent
}) => {
  const { translation } = useTranslation();

  const tabs = createVisitsTabs(translation);
  const breadcrumb = {
    title: breadcrumbTitle,
    crumbs: [{ text: translation.visitors, path: '/visits' }]
  };

  return (
    <>
      <BreadcrumbMeta breadcrumb={breadcrumb} />
      <PageTabs tabs={tabs} />
      {statTiles}
      <SearchAndFilters
        filterStr={filterStr}
        onFilterStrChange={onFilterStrChange}
        sections={sections}
        chips={chips}
        countCaption={countCaption}
      />
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <OverviewContent
          loading={loading}
          hasData={hasData}
          hasResults={hasResults}
          table={table}
          noResults={
            <EmptyStateOverview
              icon={EventBusyOutlined}
              title={translation.no_results}
              content={translation.no_results_search_and_filters_description}
            />
          }
          noData={<EmptyStateOverview icon={EventBusyOutlined} title={noDataTitle} content={noDataContent} />}
        />
      </Box>
    </>
  );
};

export default VisitsPageContent;
